module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/mypage/en-GB/btn_wp-3times.png";